////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskProductionList = {
	[ActionsTypes.RESET_DATA_KIOSK_PRODUCTION_LIST]: (state) => {
		return update(state, {
			kioskProductionList: {
				items: {
					$set: [],
				},
				labelToDisplay: { $set: null },
			},
		})
	},

	[ActionsTypes.GET_KIOSK_PRODUCTION_LIST]: (state) =>
		update(state, {
			kioskProductionList: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_PRODUCTION_LIST_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_LIST_FAILURE]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD]: (state) =>
		update(state, {
			kioskProductionList: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: null },
					battery: { $set: null },
					ws: { $set: null },
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: payload.data },
					battery: { $set: null },
					ws: { $set: null },
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD_FAILURE]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY]: (state) =>
		update(state, {
			kioskProductionList: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: null },
					battery: { $set: null },
					ws: { $set: null },
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: null },
					battery: { $set: payload.data },
					ws: { $set: null },
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY_FAILURE]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS]: (state) =>
		update(state, {
			kioskProductionList: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: null },
					battery: { $set: null },
					ws: { $set: null },
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				modalInfo: {
					simCard: { $set: null },
					battery: { $set: null },
					ws: { $set: payload.data },
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS_FAILURE]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
}

export default kioskProductionList
